import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./app/App";
import registerServiceWorker from "./registerServiceWorker";

// Style
import "./css/index.css";

ReactDOM.render(
  <App />,
  document.getElementById("root") as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx